import React from "react";
import {Box, Typography} from "@mui/material";
import {getAccount, getUser} from "../util/SessionContext";
import parkourLogo from "../assets/ParkourLogo.svg";
import {APP_NAME, BRAND, DOMAIN} from "../util/portal";

// The landing page, shown signed in or out.
//
// Signed out it sits behind the sign-in dialog and says what this site is, for the visitor who
// dismisses the dialog to read it. Signed in it names who you are and which account you are in --
// with several memberships possible, "which account am I looking at" is the first question worth
// answering. Sign out lives in the title bar.

const HEADING = "#2B2B2B";
const MUTED = "#717171";

export default function Landing({signedIn}: {signedIn: boolean}) {
    const account = signedIn ? getAccount() : null;
    const user = signedIn ? getUser() : null;

    return (
        <Box sx={{
            minHeight: "100%", display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center", textAlign: "center",
            px: 3, py: 8, boxSizing: "border-box",
        }}>
            <Box component="img" src={parkourLogo} alt="ParkourAI"
                 sx={{width: 88, height: 88, objectFit: "contain", mb: 2}}/>

            <Typography component="h1" sx={{fontSize: 32, fontWeight: 500, color: HEADING, mb: 1}}>
                {BRAND} {APP_NAME}
            </Typography>

            {user && (
                <Typography sx={{fontSize: 16, color: MUTED, lineHeight: 1.6}}>
                    Signed in as {user.Name}
                </Typography>
            )}

            {account && (
                <Typography sx={{fontSize: 16, color: HEADING, fontWeight: 500, mt: 0.5}}>
                    {account.AccountName}
                </Typography>
            )}

            <Typography sx={{fontSize: 14, color: MUTED, maxWidth: 520, lineHeight: 1.6, mt: 3}}>
                {signedIn
                    ? "Nothing has been shared with you yet. When the company you work with shares something, it will appear here."
                    : "Access is by invitation from the company you work with. Sign in to reach your workspace."}
            </Typography>

            <Typography sx={{fontSize: 12, color: MUTED, mt: 6}}>{DOMAIN}</Typography>
        </Box>
    );
}
